import React from 'react';

import Image from '$partials/media/image';
import Button from '$partials/ui/button.jsx';
import BackgroundVideo from '$partials/media/background-video';
import { useLocale } from '$contexts/locale.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ModuleTextAndImage}
 */

const ModuleTextAndImage = ({
    eyebrowTitle,
    title,
    textAndImageBody,
    cta1Link,
    cta1Label,
    cta2Link,
    cta2Label,
    image,
    orientation,
    isArticlePage,
}) => {
    const { formatURI } = useLocale();

    if (!title) { return null; }

    return (
        <section className={`layout-container layout-site-outer-padding py-40${isArticlePage ? '' : ' md:py-80'}`}>
            <div className={`col-wrapper relative flex flex-col-reverse gap-y-16 sm:flex-row ${orientation === 'Image left' ? 'sm:flex-row-reverse' : ''}`}>
                {/* Text content */}
                {/* spacer */}
                <div className='hidden md:block w-1/12 col-padding' />
                <div className='col-padding h-min my-auto sm:w-6/12 md:w-5/12 lg:w-4/12'>
                    {eyebrowTitle && (
                        <div className='flex flex-row items-center mb-12'>
                            <p className='type-style-eyebrow text-text-accent'>
                                {eyebrowTitle}
                            </p>
                        </div>
                    )}
                    <p className={`${isArticlePage ? 'type-style-4' : 'type-style-3-extended'} text-text-primary mb-10`}>
                        {title}
                    </p>
                    <p className='type-style-body text-text-secondary mb-32'>
                        {textAndImageBody}
                    </p>
                    {((cta1Label && cta1Link) || (cta2Label && cta2Link)) && (
                        <div className='flex flex-row flex-wrap items-center gap-8'>
                            {cta1Label && cta1Link && (
                                <Button
                                    as='a'
                                    className='button button--primary'
                                    href={formatURI(cta1Link)}>
                                    <span className='button__label--animate'>
                                        <span>{cta1Label}</span>
                                    </span>
                                </Button>
                            )}
                            {cta2Link && cta2Label && (
                                <Button
                                    as='a'
                                    className='button button--secondary'
                                    href={formatURI(cta2Link)}>
                                    <span className='button__label--animate'>
                                        <span>{cta2Label}</span>
                                    </span>
                                </Button>
                            )}
                        </div>
                    )}

                </div>

                {image?.contentType === 'video/mp4' ? (
                    <>
                        {/* spacer */}
                        <div className='hidden md:block w-1/12 col-padding' />
                        {/* image */}
                        <div className='sm:w-6/12 md:w-5/12 col-padding'>
                            <figure className='rounded overflow-hidden pointer-events-none select-none aspect-square h-full'>
                                <BackgroundVideo
                                    className='rounded object-cover h-full'
                                    containerClassName='w-full rounded h-full'
                                    src={image?.src}/>
                            </figure>
                        </div>
                    </>
                ) : (
                    <>
                        {/* spacer */}
                        <div className='hidden md:block w-1/12 col-padding' />

                        {/* image */}
                        <div className='sm:w-6/12 md:w-5/12 col-padding'>
                            <figure className='rounded overflow-clip relative pointer-events-none select-none aspect-square h-full'>
                                <Image
                                    className='h-full object-cover'
                                    containerClassName='h-full object-cover'
                                    height={'100%'}
                                    loading={image?.loading}
                                    loadWidth={840}
                                    src={image?.src}
                                    width={'100%'} />
                            </figure>
                        </div>
                    </>
                )}

            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default ModuleTextAndImage;
